import Swal from 'sweetalert2'

// Error messages from api returned as {message: 'error message text'}
export const logError = ({ error, customMessage = 'No custom message from backoffice' }) => {
  error?.response?.status
  	? console.log (
  		'ERROR\n' +
        `Status: ${error.response.status}.\n` +
        `Status error: ${error.response.statusText}.\n` +
        `API Message: ${error.response.data?.message}\n` +
        `Backoffice Message: ${customMessage}`
  	)
  	: console.log (
  		'ERROR\n' +
        `Backoffice message: ${customMessage}\n` +
        `${error}`
  	)
}

export const logFormData = (formData) => {
	console.group('FormData')
	for (let pair of formData.entries())
		console.log('key:', pair[0]+ ', value: '+ pair[1])

	console.groupEnd('FormData')
}

export const alertError = ({ error, message, customMessage }) => {
	console.log('alertError called')
	const msg =
    error?.response?.data?.message ||
    error?.response?.statusText ||
    error ||
    message ||
	customMessage ||
    'Error has no message'

	const params = {
		icon: 'error',
		title: (message?.length < 30 && message) || 'Ooops...',
		text: msg
	}

	Swal.fire(params)
}

export const alertSuccess = ({ message, customMessage, title } = {}) => {
	console.log('alertSuccess called')
	const msg =
    message || customMessage || 
    'Operación realizada correctamente.'

	const params = {
		icon: 'success',
		title: title || 'Éxito!',
		text: msg
	}

	Swal.fire(params)
}